export default {
  isLoading: true,
  isMobile: false,
  isWidgetOpen: null,
  parentWidth: null,
  parentHeight: null,
  settings: {},
  widgets: [],
  practiceLocations: [],
  isMobileSafari: null
}
